import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { fetchData } from './config'

interface raffle {
  raffleList: any
  raffleInfo: any
  status: any
  winnerInfo: any
}

const initialState: raffle = {
  raffleList: [],
  raffleInfo: '',
  status: '',
  winnerInfo: ''
}

export const getRaffleList = createAsyncThunk<any>('raffle/list', async () => {
  const response = await fetchData().get('/api/sweepstakes/raffle')
  const { data } = (await response).data
  return data
})

export const createRaffle = createAsyncThunk<any, any>('raffle/create', async (raffle) => {
  const response = await fetchData().post('/api/sweepstakes/raffle', raffle)
  const { data } = (await response).data
  return data
})

export const getWinner = createAsyncThunk<any, any>('raffle/winner', async (winner) => {
  const response = await fetchData().post('/api/sweepstakes/winner', winner)
  const { data } = (await response).data
  return data
})

export const setWinner = createAsyncThunk<any, any>('raffle/winner/save', async (raffle) => {
  const response = await fetchData().post('/api/sweepstakes/winner/add', raffle)
  const { data } = (await response).data
  return data
})

const raffleSlice = createSlice({
  name:'raffle',
  initialState,
  reducers:{
    setRaffle: (state, {payload}) =>{
      state.raffleInfo = payload
    },
    resetRaffle: (state) =>{
      state.raffleInfo = ''
    }
  },
  extraReducers:(builder)=>{
    builder.addCase(getRaffleList.fulfilled, (state, {payload}) => {
      state.raffleList = payload
    })
    builder.addCase(createRaffle.fulfilled, (state, {payload}) => {
      state.raffleInfo = payload
      state.status = 'createRaffle_success'
    })
    builder.addCase(createRaffle.pending, (state, {payload}) => {
      state.status = 'createRaffle_pending'
    })
    builder.addCase(createRaffle.rejected, (state, {payload}) => {
      state.status = 'createRaffle_rejected'
    })
    builder.addCase(getWinner.fulfilled, (state, {payload}) => {
      if(payload){
        state.winnerInfo = payload
      }
      state.status = 'getWinner_success'
    })
    builder.addCase(getWinner.pending, (state, {payload}) => {
      state.status = 'getWinner_pending'
    })
    builder.addCase(getWinner.rejected, (state, {payload}) => {
      state.status = 'getWinner_rejected'
    })
    builder.addCase(setWinner.fulfilled, (state, {payload}) => {
      state.status = 'setWinner_success'
    })
    builder.addCase(setWinner.pending, (state, {payload}) => {
      state.status = 'setWinner_pending'
    })
    builder.addCase(setWinner.rejected, (state, {payload}) => {
      state.status = 'setWinner_rejected'
    })
  }
})

export default raffleSlice.reducer
export const { setRaffle, resetRaffle } = raffleSlice.actions;